import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tekman-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
})
export class ExpansionPanelComponent {
  @Input() open: boolean;
  @Input() title: string;
  @Output() openEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggleAll() {
    this.open = !this.open;
    this.openEmitter.emit(this.open);
  }
}
